import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/common/services/user.service';
import * as feather from "feather-icons";
import { MemberProfile } from 'src/app/common/models/profile';
import { PracticeAreas } from 'src/app/common/models/practiceAreas';
import { PlanEditService } from 'src/app/common/services/plan-edit.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dialog-confirm-profile',
    templateUrl: './dialog-confirm-profile.component.html',
    styleUrls: ['./dialog-confirm-profile.component.css'],
    standalone: false
})
export class DialogConfirmProfileComponent implements OnInit, AfterViewInit {

  profile: MemberProfile;
  practiceAreas: PracticeAreas;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {userId: string, isEditing: boolean}, public dialogRef: MatDialogRef<DialogConfirmProfileComponent>, private userService: UserService, private planEditService: PlanEditService)
  {
  }
  ngOnInit(){
    this.userService.profile().subscribe({
      next: (p) => this.profile = p
    });
    this.userService.practiceAreas().subscribe({
      next: (pa) => this.practiceAreas = pa
    });
  }

  ngAfterViewInit(): void {
      feather.replace();
  }

  return(): void {
    this.planEditService.clear();
    window.location.href = environment.PortalURL;
  }
}
